import { useDispatch, useSelector } from "react-redux";
import lodashGet from 'lodash/get';

/* MUI components */
import { Button, CircularProgress, IconButton, ListItem, ListItemText } from "@mui/material";

/* Redux */
import { ActionSelectClient, ActionUnselectClient } from "../../redux/actions/contextApp";

/* Traduction */
import StringTranslate from '../../assets/i18n/stringLanguage.jsx';

/* Utils Helper */
import stringHelper from "../../utils/stringHelper.js";
import { useEffect, useState } from "react";
import { PlayArrow } from "@mui/icons-material";
import StopIcon from '@mui/icons-material/Stop';
import { useTheme } from "@emotion/react";

/**
 * Ligne de client dans le portfolio
 * @typedef {Object} ClientRowProps
 * @property {Object} clientInfos Informations du client
 * @property {number} maxLength Taille maximale des textes, 20 par default
 * @param {ClientRowProps} props
 * @returns {JSX.Element}
 */
const ClientRow = ({ clientInfos, maxLength = 20 }) => {
  const dispatch = useDispatch();
  const selectedClientId = useSelector((state) => lodashGet(state, 'contextAppData.selectedClientId', null));
  const clientLoading = useSelector((state) => lodashGet(state, 'contextAppData.clientLoading', false));
  const [primaryName, setPrimaryName] = useState('');
  const [secondaryName, setSecondaryName] = useState('');

  const isChosen = selectedClientId === clientInfos.id;
  const isLoading = isChosen && clientLoading;

  const theme = useTheme();

  useEffect(() => {
    const companyName = clientInfos.compagnyName;
    const fullName = `${clientInfos.lastname} ${clientInfos.firstname}`;
    const clientEmail = clientInfos.email;

    // on préférera afficher la raison sociale du compte Agri en suivi (à défaut : son nom  prénom):
    if (companyName) {
      setPrimaryName(stringHelper.truncateString(companyName, maxLength));
    } else {
      setPrimaryName(stringHelper.truncateString(fullName, maxLength));
    }

    setSecondaryName(stringHelper.truncateString(clientEmail, maxLength));

  }, [maxLength, clientInfos]);

  const handleChooseClient = () => {
    dispatch(ActionSelectClient(clientInfos.id));
  };

  const handleUnselectClient = () => {
    dispatch(ActionUnselectClient());
  };

  const button = (
    <>
      <Button
        disabled={isLoading}
        variant="contained"
        sx={{ mr: 3, display: { xs: 'none', sm: 'inline-flex' } }}
        onClick={isChosen ? handleUnselectClient : handleChooseClient}>
        {isChosen ?
          (isLoading ? <CircularProgress size={20} /> : StringTranslate.unselectItem)
          :
          StringTranslate.selectItem
        }
      </Button>
      <IconButton
        sx={{
          bgcolor: isChosen ? theme.palette.error.main : theme.palette.primary.main,
          color: theme.palette.common.white,
          display: { xs: 'inline-flex', sm: 'none' },
          mr: 3
        }}
        disabled={isLoading}
        onClick={isChosen ? handleUnselectClient : handleChooseClient}
      >
        {isChosen ? (
          isLoading ? <CircularProgress size={20} /> : <StopIcon />
        ) : (
          <PlayArrow />
        )}
      </IconButton>
    </>
  );

  return (
    <ListItem
      sx={{ pt: 0, pb: 0, minWidth: '300px' }}
      disableGutters
      secondaryAction={button}>
      <ListItemText
        primary={primaryName}
        secondary={secondaryName} />
    </ListItem>
  );
};

export default ClientRow;

